import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
//import InsuranceClaimApplication from '../views/InsuranceClaimApplication.vue'
//import InsurancePreviewApplication from '../views/InsurancePreviewApplication.vue'
//import ClaimApplicationAuto from '../views/ClaimApplicationAuto.vue'
//import ClaimApplicationHealth from '../views/ClaimApplicationHealth.vue'
//import ClaimApplicationTourism from '../views/ClaimApplicationTourism.vue'
//import ClaimApplicationProperty from '../views/ClaimApplicationProperty.vue'
import Claim from '../views/Claim.vue'
import Loss from '../views/Loss.vue'
import Sign from '../views/Sign.vue'

const routes = [
	{ path: '/', name: 'Home', component: Home },
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: function () {
			return import(/* webpackChunkName: "about" */ '../views/About.vue')
		}
	},
	{ path: '/login', name: 'Login', component: Login },
	{ path: '/claim', name: 'Claim', component: Claim },
	{ path: '/loss', name: 'Loss', component: Loss },
	{ path: '/sign', name: 'Sign', component: Sign },
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router